const personalInfoData = {
  name: 'Vishal Gaglani + UX + Development',
  linkedIn: 'https://www.linkedin.com/in/vishal-gaglani-25525219',
  github: 'https://github.com/vishalgaglani',
  resume: ''
};

export { personalInfoData };



/** WEBPACK FOOTER **
 ** ./src/data/personalInfo.js
 **/